import graphql__870d575f9e550b8b5967 from "./__generated__/AddContactDialogContactsQuery.graphql.ts";
import graphql__23b4e4bf7c02cf1db976 from "./__generated__/AddContactDialog_customerAccount.graphql.ts";
import graphql__8134c69aa18869ef13bc from "./__generated__/AddContactDialogMutation.graphql.ts";import * as React from "react";
import {fetchQuery, graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import asFormikField from "../abstract/asFormikField";
import AbstractCombobox from "../abstract/AbstractCombobox";
import { useIntl } from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type AddContactDialogProps = {
    customerAccount: any,
    handleCloseDialog: () => {}
}

const contactsDataProvider = (relayEnvironment) => {
    return AwesomeDebouncePromise((searchTerm: String = '') => {
        return fetchQuery(relayEnvironment, graphql__870d575f9e550b8b5967, {searchTerm}).toPromise().then((data) => {
            if (!data) {
                return [];
            }
            //@ts-ignore
            return data.contacts?.edges?.map((edge) => edge.node) || [];
        });
    }, 500);
}

const AddContactDialog: React.FC<AddContactDialogProps> = (props) => {
    const customerAccount = useFragment(
        graphql__23b4e4bf7c02cf1db976,
        props.customerAccount
    );

    const relayEnvironment = useRelayEnvironment();
    const intl = useIntl();
    const {addError} = useErrorContext();
    
    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__8134c69aa18869ef13bc,
                variables: {
                    input: {
                        customerAccountIdentifier: input.customerAccountIdentifier,
                        contactIdentifier: input.contactIdentifier?.id || null
                    }
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToAddContact'})
            }
        )
    }

    const initialValues = {
        customerAccountIdentifier: customerAccount.id
    }

    const validationSchema = yup.object().shape({
        contactIdentifier: yup.object()
            .required(intl.formatMessage({id: 'validation.field.required'})),
    });

    const FormikCombobox = asFormikField(AbstractCombobox, 'contactIdentifier');
    const getEntryLabel = (contact) => {
        switch (contact.__typename) {
            case 'PersonContact':
                return contact.givenName + ' ' + contact.familyName
            case 'TeamContact':
                return contact.teamName
        }
        return contact?.id
    }
    const getEntrySecondaryLabel = (contact) => {
        return contact?.emailAddress
    }

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} validationSchema={validationSchema} headline={intl.formatMessage({id: 'dialog.AddContactDialog.headline'})} submitLabel={intl.formatMessage({id: 'dialog.AddContactDialog.submitLabel'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.AddContactDialog.label'})}</Label>
                    <FormikCombobox getEntryId={(contact) => contact.id} getEntryLabel={getEntryLabel} getEntrySecondaryLabel={getEntrySecondaryLabel} dataProvider={contactsDataProvider(relayEnvironment)} autoFocus={true} placeholder={intl.formatMessage({id: 'dialog.AddContactDialog.searchForContact'})}/>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default AddContactDialog;
